<i
  class="fa btn-star"
  [ngClass]="{
    'active_star fa-star': mailInfo.user_focus,
    'fa-star-o': !mailInfo.user_focus
  }"
  (click)="clickStar($event)"
>
</i>
